export enum TabIds {
  ABOUT = 'about',
  RESTART = 'restart',
  CHANGE_COMPUTE_TYPE = 'change-compute-type',
  INCREASE_DISK_SIZE = 'increase-disk-size',
  SWITCH_RUNNING_MODE = 'switch-running-mode',
  REBUILD = 'rebuild',
}
